// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3dFo0","title":"Info_title__13px7","selects":"Info_selects__2DyV2","requiredAsterisk":"Info_requiredAsterisk__1N3jS"};